<template>
  <Dialog
    :visible.sync="display"
    :style="{ width: '90vw' }"
    :modal="true"
    :closable="false"
  >
    <div>
      <Dropdown
        v-model="selectedDayType"
        :options="dayTypes"
        optionLabel="name"
      />
    </div>
    <template #header>
      <span>{{ $t("DaySelector.SelectDay") }}</span>
    </template>
    <div>
      <Listbox
        v-model="selectedDays"
        :options="days"
        :multiple="true"
        style="width:100%; min-height:200px;"
      >
        <template #option="slotProps">
          <div
            class="p-clearfix"
            v-bind:class="{ faded: slotProps.option.disabled }"
            style="min-height:25px"
          >
            <span>{{ slotProps.option.name }}</span>
          </div>
        </template>
      </Listbox>
    </div>
    <template #footer>
      <Button
        :disabled="!isValid"
        :label="$t('DaySelector.Insert')"
        icon="pi pi-check"
        @click="onClick(true)"
      />
      <Button
        :label="$t('DaySelector.Cancel')"
        icon="pi pi-times"
        @click="onClick(false)"
        class="p-button-secondary"
      />
    </template> </Dialog
></template>
<script>
export default {
  name: "DaySelector",
  props: { display: {
    type: Boolean,
    default: false
  }, disabledDays: null },
  data() {
    return {
      days: null,
      selectedDays: null,
      selectedDayType: null,
      dayTypes: [
        { name: this.$t("DaySelector.Standard"), value: 1 },
        { name: this.$t("DaySelector.Leave"), value: 2 },
        { name: this.$t("DaySelector.Sick"), value: 3 },
      ],
    };
  },
  computed: {
    // a computed getter
    isValid() {
      // `this` points to the vm instance
      return (
        this.selectedDays &&
        this.selectedDays.length > 0 &&
        this.selectedDays.findIndex((s) => !s.disabled) > -1
      );
    },
  },
  watch: {
    display() {
      this.selectedDays = null;
      this.selectedDayType = this.dayTypes[0];
    },
    disabledDays() {
      this.days = [
        {
          id: 1,
          name: this.$t("DaySelector.Monday"),
          disabled: this.disabledDays.indexOf(1) > -1,
        },
        {
          id: 2,
          name: this.$t("DaySelector.Tuesday"),
          disabled: this.disabledDays.indexOf(2) > -1,
        },
        {
          id: 3,
          name: this.$t("DaySelector.Wednesday"),
          disabled: this.disabledDays.indexOf(3) > -1,
        },
        {
          id: 4,
          name: this.$t("DaySelector.Thursday"),
          disabled: this.disabledDays.indexOf(4) > -1,
        },
        {
          id: 5,
          name: this.$t("DaySelector.Friday"),
          disabled: this.disabledDays.indexOf(5) > -1,
        },
        {
          id: 6,
          name: this.$t("DaySelector.Saturday"),
          disabled: this.disabledDays.indexOf(6) > -1,
        },
        {
          id: 7,
          name: this.$t("DaySelector.Sunday"),
          disabled: this.disabledDays.indexOf(0) > -1,
        },
      ];
    },
  },
  methods: {
    onClick(value) {
      if (value) {
        if (!this.isValid) {
          return;
        }
        this.$emit("confirmed", {
          value: value,
          days: this.selectedDays.map((s) => s.id),
          dayType: this.selectedDayType.value,
        });
      } else {
        this.$emit("confirmed", {
          value: value,
        });
      }
    },
  },
};
</script>
<style scoped>
.faded {
  opacity: 0.4;
}
</style>
